import * as CONSTRUCTOR from '../../generate';

export const createOppTokenResponse = CONSTRUCTOR.FRAGMENT({
  name: 'OppToken',
  fragmentName: 'CreateOppTokenResponseFields',
  fields: `{
    id
    company_id
    opportunity_id
    project_id
    unit_id
    buyer_aws_id
    display_token
    status
    currency_code
    amount_minor
    amount_minor_paid
    created_at
    updated_at
    expiry_at
    paid_at
  }`,
});

export const fetchListTokensResponse = CONSTRUCTOR.FRAGMENT({
  name: 'BMSFetchTokensResponse',
  fragmentName: 'FetchListTokensResponseFields',
  fields: `{
    tokens {
      id
      company_id
      opportunity_id
      project_id
      display_token
      status
      amount_minor
      currency_code
      expiry_at
      paid_at
      created_at
      updated_at
      payments {
        id
        token_id
        amount_minor
        currency_code
        method
        reference_number
        status
        paid_at
        paid_by_buyer_name
        receipt_media_id
        created_at
      }
    }
    total_count
    page
    page_size
  }`,
});

export const fetchTokenDetailsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'OppToken',
  fragmentName: 'FetchTokenDetailsResponseFields',
  fields: `{
    id
    company_id
    opportunity_id
    project_id
    unit_id
    buyer_aws_id
    display_token
    status
    currency_code
    amount_minor
    amount_minor_paid
    payments {
      id
      token_id
      amount_minor
      currency_code
      method
      status
      paid_at
      created_at
    }
    created_at
    updated_at
    expiry_at
    paid_at
  }`,
});

export const createTokenPaymentResponse = CONSTRUCTOR.FRAGMENT({
  name: 'TokenPayment',
  fragmentName: 'CreateTokenPaymentResponseFields',
  fields: `{
    id
    token_id
    amount_minor
    currency_code
    method
    reference_number
    status
    paid_at
    paid_by_buyer_name
    created_at
    updated_at
  }`,
});

export const listTokenPaymentsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'TokenPayment',
  fragmentName: 'ListTokenPaymentsResponseFields',
  fields: `{
    id
    token_id
    amount_minor
    currency_code
    method
    reference_number
    status
    paid_at
    paid_by_buyer_name
    created_at
    updated_at
  }`,
});
